//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


export class ConsentType
{
    static Newsletter: string = "Newsletter";
    static Opineo: string = "Opineo";
    static Contact: string = "Contact";
    static ConditionsOfUse: string = "ConditionsOfUse";
    static PrivacyPolicy: string = "PrivacyPolicy";
    static ContactRequestProcessing: string = "ContactRequestProcessing";
}

export interface GeneralSeo
{
    defaultOGImage?: string | undefined;
}

export interface SliderOptions
{
    transitionSpeed?: number;
    autoPlayDelay?: number;
    autoPlayStopOnLastSlide?: boolean;
    autoPlayDisableOnInteraction?: boolean;
    autoPlayReverseDirection?: boolean;
    autoPlayWaitForTransition?: boolean;
}

export interface BannerOption
{
    fontColor?: string | undefined;
    backgroundColor?: string | undefined;
    backgroundOpacity?: number;
    captionBoxEnabled?: boolean;
    caption?: string | undefined;
    callToActionText?: string | undefined;
    callToActionLink?: string | undefined;
    callToActionClipboard?: string | undefined;
    callToActionClipboardSuccessMessage?: string | undefined;
}

export interface BannerOptions
{
    mobile?: BannerOption;
    desktop?: BannerOption;
    tablet?: BannerOption;
    selected?: BannerOption;
}

export interface ImageOptionElement
{
    url?: string | undefined;
    width?: number;
    height?: number;
    xOffset?: number;
    yOffset?: number;
    zoom?: number;
    cropType?: string | undefined;
}

export interface ResponsiveImageElement
{
    url?: string | undefined;
    mobile?: ImageOptionElement;
    tablet?: ImageOptionElement;
    desktop?: ImageOptionElement;
}

export interface ResponsiveBanner
{
    type?: string | undefined;
    enabled?: boolean;
    name?: string | undefined;
    discountPercent?: number | undefined;
    promotionCode?: string | undefined;
    options?: BannerOptions;
    image?: ResponsiveImageElement;
    position?: TilePosition;
}


export interface Banners
{
    items?: ResponsiveBanner[] | undefined;
}

export interface BannerList
{
    options?: SliderOptions;
    banners?: Banners;
}

export interface ShopReview
{
    nick?: string | undefined;
    description?: string | undefined;
    creationDate?: Date;
    rating?: number;
}

export interface TilePosition
{
    left?: number;
    right?: number;
    top?: number;
    bottom?: number;
}

export interface TileContent
{
    type?: string | undefined;
    text?: string | undefined;
    caption?: string | undefined;
    captionForeColor?: string | undefined;
    callToActionText?: string | undefined;
    callToActionLink?: string | undefined;
    image?: ResponsiveImageElement;
    position?: TilePosition;
    className?: string | undefined;
}

export interface Tiles
{
    list?: TileContent[] | undefined;
}

export interface OpinionElement
{
    sourceIcon?: string | undefined;
    author?: string | undefined;
    creationDate?: Date;
    description?: string | undefined;
}

export interface Inspiration
{
    images?: ResponsiveImageElement[] | undefined;
    opinion?: OpinionElement;
    products?: string[] | undefined;
}

export interface Inspirations
{
    list?: Inspiration[] | undefined;
}

export interface Services
{
    codes?: string[] | undefined;
}

export interface LinkElement
{
    text?: string | undefined;
    url?: string | undefined;
}

export interface FooterColumnElement
{
    name?: string | undefined;
    isExpanded?: boolean;
    links?: LinkElement[] | undefined;
}

export interface Footer
{
    columns?: FooterColumnElement[] | undefined;
}

export interface Header
{
    links?: LinkElement[] | undefined;
}

export interface Sliders
{
    recentlyWatchedProducts?: string | undefined;
    newProducts?: string | undefined;
    newProductsOld?: string | undefined;
    chosenProducts?: string | undefined;
    emptyCart?: string | undefined;
    error404?: string | undefined;
}

export interface Day
{
    from?: string | undefined;
    to?: string | undefined;
}

export interface OpenHoursLimited
{
    weekday?: Day;
    saturday?: Day;
    sunday?: Day;
}

export interface BankAccount
{
    number?: string | undefined;
    bankName?: string | undefined;
}

export interface Ecommerce
{
    primaryPhoneNumber?: string | undefined;
    secondaryPhoneNumber?: string | undefined;
    email?: string | undefined;
    bankAccount?: BankAccount;
}

export interface Company
{
    name?: string | undefined;
    address?: string | undefined;
    registration1?: string | undefined;
    primaryPhoneNumber?: string | undefined;
    secondaryPhoneNumber?: string | undefined;
    email?: string | undefined;
    bankAccount?: BankAccount;
}

export interface Employee
{
    name?: string | undefined;
    position?: string | undefined;
    primaryImage?: string | undefined;
    secondaryImage?: string | undefined;
    description?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
}

export interface Department
{
    name?: string | undefined;
    employees?: Employee[] | undefined;
}

export interface Contact
{
    mainImage?: string | undefined;
    mainImageResponsive?: ResponsiveImageElement;
    openHours?: OpenHoursLimited;
    ecommerce?: Ecommerce;
    company?: Company;
    departments?: Department[] | undefined;
}

export interface ContactWrapper
{
    contact?: Contact;
}

export interface Common
{
    virtualTourImage?: string | undefined;
    virtualTourTabletImage?: string | undefined;
    virtualTourCaption?: string | undefined;
    virtualTourCallToActionText?: string | undefined;
    slider?: string | undefined;
}

export interface Coordinates
{
    latitude?: number;
    longitude?: number;
}

export interface OpenHours
{
    monday?: Day;
    tuesday?: Day;
    wednesday?: Day;
    thursday?: Day;
    friday?: Day;
    saturday?: Day;
    sunday?: Day;
}

export interface ShopImage
{
    name?: string | undefined;
    image?: string | undefined;
    thumb?: string | undefined;
}

export interface Shop
{
    code?: string | undefined;
    url?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    fullName?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    postCode?: string | undefined;
    address?: string | undefined;
    coordinates?: Coordinates;
    googlePlaceID?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    virtualTourLink?: string | undefined;
    assortment?: string | undefined;
    message?: string | undefined;
    services?: string[] | undefined;
    openHours?: OpenHours;
    ogImage?: string | undefined;
    cloudImage?: string | undefined;
    images?: ShopImage[] | undefined;
}

export interface Shops
{
    common?: Common;
    locations?: Shop[] | undefined;
}

export interface MessageItem
{
    title?: string | undefined;
    code?: string | undefined;
    type?: string | undefined;
    message?: string | undefined;
}

export interface Messages
{
    list?: MessageItem[] | undefined;
}

export interface ErrorPage
{
    code?: string | undefined;
    caption?: string | undefined;
    text?: string | undefined;
    image?: string | undefined;
    imageMobile?: string | undefined;
    imageTablet?: string | undefined;
}

export interface ErrorPages
{
    pages?: ErrorPage[] | undefined;
}

export interface Popup
{
    enabled?: boolean;
    showOnPages?: string[] | undefined;
    doNotShowOnPages?: string[] | undefined;
    markAsShownOnPages?: string[] | undefined;
    description1?: string | undefined;
    discountValue?: string | undefined;
    promotionCode?: string | undefined;
    callToAction?: string | undefined;
    imageUrl?: string | undefined;
    showDelay?: number;
}

export interface Popups
{
    list?: Popup[] | undefined;
}

export interface Link
{
    url?: string | undefined;
    code?: string | undefined;
}

export interface Links
{
    list?: Link[] | undefined;
}

export interface SimpleBanner
{
    image?: string | undefined;
    caption?: string | undefined;
    captionShort?: string | undefined;
    callToActionText?: string | undefined;
    callToActionLink?: string | undefined;
}

export interface Snippet
{
    code?: string | undefined;
    caption?: string | undefined;
    text?: string | undefined;
    link?: string | undefined;
    imageUrl?: string | undefined;
}

export interface Snippets
{
    list?: Snippet[] | undefined;
}

export interface WireTransfer
{
    bankAccountNumber?: string | undefined;
    companyName?: string | undefined;
    companyAddress?: string | undefined;
}

export interface ConsentContent
{
    collapsedText?: string | undefined;
    expandedText?: string | undefined;
}

export interface Consent
{
    text?: string | undefined;
    error?: string | undefined;
    code?: string;
    global?: boolean;
    defaultChecked?: boolean;
    required?: boolean;
    accepted?: boolean;
    simpleContent?: string | undefined;
    showCollapsingContent?: boolean;
    showSimpleContent?: boolean;
    collapsingContent?: ConsentContent;
    expand?: boolean;
}

export interface Placement
{
    code?: string | undefined;
    consents?: Consent[] | undefined;
}

export interface Consents
{
    items?: Placement[] | undefined;
}

export interface Socalmedia
{
    facebookLink?: string | undefined;
    instagramLink?: string | undefined;
    pinterestLink?: string | undefined;
}

export interface InstagramImage
{
    url?: string | undefined;
    image?: ImageOptionElement;
}

export interface InstagramImages
{
    list?: InstagramImage[] | undefined;
}

export interface MenuCategoryAttributeValue
{
    value?: string | undefined;
    code?: string | undefined;
    imageUrl?: string | undefined;
}

export interface MenuCategoryAttribute
{
    name?: string | undefined;
    code?: string | undefined;
    promotion?: boolean;
    linkTemplate?: string | undefined;
    values?: MenuCategoryAttributeValue[] | undefined;
}

export interface MenuBanner
{
    name?: string | undefined;
    text?: string | undefined;
    caption?: string | undefined;
    captionForeColor?: string | undefined;
    callToActionText?: string | undefined;
    callToActionLink?: string | undefined;
    image?: string | undefined;
    position?: any | undefined;
}

export interface MenuCategory
{
    name?: string | undefined;
    link?: string | undefined;
    code?: string | undefined;
    urlParams?: any | undefined;
    bannerLink?: string | undefined;
    description?: string | undefined;
    promotion?: boolean;
    subCategories?: MenuCategory[] | undefined;
    attributes?: MenuCategoryAttribute[] | undefined;
    banner?: MenuBanner;
}

export interface Menu
{
    categories?: MenuCategory[] | undefined;
}

export interface Number
{
    value?: number;
    maxValue?: number;
    text?: string | undefined;
}

export interface InNumbers
{
    caption?: string | undefined;
    text?: string | undefined;
    numbers?: Number[] | undefined;
}

export interface AboutUs
{
    mainImage?: ResponsiveImageElement;
    secondaryImages?: ResponsiveImageElement[] | undefined;
    header?: string | undefined;
    ourExperienceFirst?: string | undefined;
    ourExperienceImage?: ResponsiveImageElement;
    ourExperienceSecond?: string | undefined;
    inNumbers?: InNumbers;
    departments?: Department[] | undefined;
}

export interface ThumbImageElement
{
    url?: string | undefined;
    oneByTwo?: ImageOptionElement;
    oneByOne?: ImageOptionElement;
    twoByTwo?: ImageOptionElement;
    mobileBig?: ImageOptionElement;
    mobileSmall?: ImageOptionElement;
}

export interface BlogHeader
{
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    directPath?: boolean;
    blogPath?: boolean;
    listed?: boolean;
    tags?: string[] | undefined;
    creationDate?: Date;
    enabled?: boolean;
    thumbImages?: ThumbImageElement;
    lastModified?: Date;
}

export interface Content
{
    readonly id?: number;
    title?: string | undefined;
    code?: string | undefined;
    route?: string | undefined;
    createdDate?: Date;
    enabled?: boolean;
    deleted?: boolean;
    contentType?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    resolvedContent?: string | undefined;
    resolvedJson?: any | undefined;
    format?: string | undefined;
    readonly sidebars?: string[] | undefined;
}

export interface Aggregate
{
    generalSeo?: GeneralSeo;
    banner?: BannerList;
    reviews?: ShopReview[] | undefined;
    tiles?: Tiles;
    inspirations?: Inspirations;
    services?: Services;
    footer?: Footer;
    header?: Header;
    sliders?: Sliders;
    contact?: ContactWrapper;
    shops?: Shops;
    messages?: Messages;
    errorPages?: ErrorPages;
    autoShowPopup?: Popups;
    cmsLinks?: Links;
    coveringBanner?: SimpleBanner;
    snippets?: Snippets;
    wireTransfer?: WireTransfer;
    consents?: Consents;
    socalmedia?: Socalmedia;
    instagramImages?: InstagramImages;
    menu?: Menu;
    aboutUs?: AboutUs;
    translation?: string | undefined;
    friendlyUrls?: { [key: string]: string; } | undefined;
    blogHeaders?: BlogHeader[] | undefined;
    blocks?: Content[] | undefined;
    pages?: Content[] | undefined;
}

export interface Margin
{
    desktop?: number;
    tablet?: number;
    mobile?: number;
}

export interface BlogBlock
{
    type?: string | undefined;
    content?: any | undefined;
    margin?: Margin;
    anchor?: string | undefined;
}

export interface BlogContent
{
    mainImage?: ResponsiveImageElement;
    code?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    metaDescription?: string | undefined;
    metaKeywords?: string | undefined;
    metaTitle?: string | undefined;
    author?: string | undefined;
    ldJson?: any | undefined;
    ogImage?: any | undefined;
    creationDate?: Date;
    modifiedDate?: Date;
    blocks?: BlogBlock[] | undefined;
    searchImages?: string[] | undefined;
}